import { Button, Pagination } from "antd";

import Icon from '../../../components/Icon/Icon';
import Popup from '../../../components/Popup/Popup';
import Spinner from '../../../components/Spinner/Spinner';
import Tag from '../../../components/Tag/Tag';

import { pageSize, useAdminsTab } from "./useAdminsTab";

import { Admin, Props, TabStatus } from "./AdminsTab.model";
import { Status } from "./AdminsTab.model";

import styles from "./AdminsTab.module.scss";
import { FormattedMessage, useIntl } from "react-intl";
import {useAuthenticationDataContext} from "../../../Helpers/AuthenticationDataProvider";
import ErrorMessage from "../../../components/ErrorMessage/ErrorMessage";

const AdminsTab = ({ filters }: Props) => {
	const {
		deleteUser,
		getAdmins,
		isAuthorized,
		onChangeAdminsPagination,
		reinviteAdmin,
		setAdminToDelete,
		state,
	} = useAdminsTab({filters});
	const {
		adminToDelete,
		admins,
		adminsPagination,
		tabStatus
	} = state;
	const intl = useIntl();

	const { userId } = useAuthenticationDataContext();
	
	const getTagByStatus = (admin: Admin) => {
		const { isActive, reinvite } = admin;
		if (isActive) {
			return { color: 'green', status: intl.formatMessage({id: `status.${Status.Active}`})}
		}
		else if (reinvite) {
			return {color: 'red', status:intl.formatMessage({id: `status.${Status.Expired}`})}
		}
		else return { color: 'grey', status: intl.formatMessage({id: `status.${Status.Pending}`})}
	}

	const renderCard = (item: Admin) => {
		const { color, status } = getTagByStatus(item);
		return <div className={styles.card} key={item.userId}>
			<div className={styles.imageWrapper}>

				{item.imageId ?
					<img alt="Profile" src={item.imageId} /> :
					<div className={styles.initials}>{item.firstName[0]}{item.lastName[0]}</div>}
			</div>
			<div>
				<h1>{item.firstName} {item.lastName}</h1>
				<Tag color="orange"><FormattedMessage id="role.Admin"/></Tag>
			</div>
			<div className={styles.status}>
				{!item.isActive && <Button className={styles.reinviteBtn} size="large" type="default" onClick={reinviteAdmin.bind(null, item.userId)}><FormattedMessage id="buttons.reinvite" /></Button>}
				<Tag color={color} noBackground>{status}</Tag>
				{isAuthorized(['DeleteUsers']) && userId !== item.userId && <Button icon={<Icon name="trash" height="14px" width="14px" />} onClick={() => setAdminToDelete(item)} size="large" type="link" />}
			</div>
		</div>
	}
	return <div className={styles.tabContent}>
		<Spinner spinning={tabStatus === TabStatus.Loading} />
		<ErrorMessage error={tabStatus === TabStatus.Error} onRefresh={getAdmins} showReport={false}/>
		<div className={styles.cards} >{admins && admins.map((admin: any, index: number) => renderCard(admin))}</div>
		<div className={styles.paginationWrapper}>
			<Pagination
				className={styles.pagination}
				current={adminsPagination.page}
				pageSize={pageSize}
				total={adminsPagination.total}
				onChange={onChangeAdminsPagination}
				showSizeChanger={false}
			/>
		</div>
		{adminToDelete &&
			<Popup
				actions={<>
					<Button size="large" type="default" onClick={() => setAdminToDelete(null)}><FormattedMessage id="buttons.cancel" /></Button>
					<Button danger size="large" type="primary" onClick={() => { deleteUser(adminToDelete.userId); setAdminToDelete(null) }}><FormattedMessage id="buttons.delete" /></Button>
				</>}
				onClose={() => setAdminToDelete(null)}
				title={{ action: 'delete', target: 'user' }}>
		
			<div className={styles.popupContent}>
				<FormattedMessage
					id="userProfile.deleteUserQuestion"
					values={{ b: (...chunks: any) => <b><i>{chunks}</i></b>, name: `${adminToDelete.firstName} ${adminToDelete.lastName}` }}
				/>
			</div>
		</Popup>}
	</div>
}
export default AdminsTab;